module.exports = __webpack_public_path__ + "static/media/nav-desktop-arrow-r.bb079b17.svg";